import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/prof/prof/deps/docs/src/components/AutoDocLayout.jsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Name`}</h2>
    <p><strong parentName="p">{`step ca provisioner webhook add`}</strong>{` -- add a webhook to a provisioner`}</p>
    <h2>{`Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-raw"
      }}>{`step ca provisioner webhook add <provisioner_name> <webhook_name>
[--url=<url>] [--kind=<kind>] [--bearer-token-file=<filename>]
[--basic-auth-username=<username>] [--basic-auth-password-file=<filename>]
[--disable-tls-client-auth] [--cert-type=<cert-type>]
[--admin-cert=<file>] [--admin-key=<file>] [--admin-subject=<subject>]
[--admin-provisioner=<name>] [--admin-password-file=<file>]
[--ca-url=<uri>] [--root=<file>] [--context=<name>] [--ca-config=<file>]
`}</code></pre>
    <h2>{`Description`}</h2>
    <p><strong parentName="p">{`step ca provisioner webhook add`}</strong>{` adds a webhook to a provisioner.`}</p>
    <p>{`The command will print the webhook ID and secret that must be used to verify all requests from step CA.`}</p>
    <h2>{`Positional arguments`}</h2>
    <p><inlineCode parentName="p">{`provisioner_name`}</inlineCode>{`
The name of the provisioner.`}</p>
    <p><inlineCode parentName="p">{`webhook_name`}</inlineCode>{`
The name of the webhook.`}</p>
    <h2>{`Options`}</h2>
    <p><strong parentName="p">{`--url`}</strong>{`=`}<inlineCode parentName="p">{`value`}</inlineCode>{`
The url of the webhook server.`}</p>
    <p><strong parentName="p">{`--kind`}</strong>{`=`}<inlineCode parentName="p">{`value`}</inlineCode>{`
The kind of webhook. Default is ENRICHING.`}</p>
    <p><strong parentName="p">{`--bearer-token-file`}</strong>{`=`}<inlineCode parentName="p">{`value`}</inlineCode>{`
The token to be set in the Authorization header of the request to the webhook server.`}</p>
    <p><strong parentName="p">{`--basic-auth-username`}</strong>{`=`}<inlineCode parentName="p">{`value`}</inlineCode>{`
The username portion of the Authorization header of the request to the webhook server when using basic authentication.`}</p>
    <p><strong parentName="p">{`--basic-auth-password-file`}</strong>{`=`}<inlineCode parentName="p">{`value`}</inlineCode>{`
The password porition of the Authorization header of the request to the webhook server when using basic authentication.`}</p>
    <p><strong parentName="p">{`--disable-tls-client-auth`}</strong>{`
The CA will not send a client certificate when requested by the webhook server.`}</p>
    <p><strong parentName="p">{`--cert-type`}</strong>{`=`}<inlineCode parentName="p">{`value`}</inlineCode>{`
Whether to call this webhook when signing X509 certificates, SSH certificates, or ALL certificates. Default is ALL.`}</p>
    <p><strong parentName="p">{`--admin-cert`}</strong>{`=`}<inlineCode parentName="p">{`chain`}</inlineCode>{`
Admin certificate (`}<inlineCode parentName="p">{`chain`}</inlineCode>{`) in PEM format to store in the 'x5c' header of a JWT.`}</p>
    <p><strong parentName="p">{`--admin-key`}</strong>{`=`}<inlineCode parentName="p">{`file`}</inlineCode>{`
Private key `}<inlineCode parentName="p">{`file`}</inlineCode>{`, used to sign a JWT, corresponding to the admin certificate that will
be stored in the 'x5c' header.`}</p>
    <p><strong parentName="p">{`--admin-subject`}</strong>{`=`}<inlineCode parentName="p">{`subject`}</inlineCode>{`, `}<strong parentName="p">{`--admin-name`}</strong>{`=`}<inlineCode parentName="p">{`subject`}</inlineCode>{`
The admin `}<inlineCode parentName="p">{`subject`}</inlineCode>{` to use for generating admin credentials.`}</p>
    <p><strong parentName="p">{`--admin-provisioner`}</strong>{`=`}<inlineCode parentName="p">{`name`}</inlineCode>{`, `}<strong parentName="p">{`--admin-issuer`}</strong>{`=`}<inlineCode parentName="p">{`name`}</inlineCode>{`
The provisioner `}<inlineCode parentName="p">{`name`}</inlineCode>{` to use for generating admin credentials.`}</p>
    <p><strong parentName="p">{`--admin-password-file`}</strong>{`=`}<inlineCode parentName="p">{`file`}</inlineCode>{`, `}<strong parentName="p">{`--password-file`}</strong>{`=`}<inlineCode parentName="p">{`file`}</inlineCode>{`
The path to the `}<inlineCode parentName="p">{`file`}</inlineCode>{` containing the password to decrypt the one-time token
generating key.`}</p>
    <p><strong parentName="p">{`--ca-url`}</strong>{`=`}<inlineCode parentName="p">{`URI`}</inlineCode>{`
`}<inlineCode parentName="p">{`URI`}</inlineCode>{` of the targeted Step Certificate Authority.`}</p>
    <p><strong parentName="p">{`--root`}</strong>{`=`}<inlineCode parentName="p">{`file`}</inlineCode>{`
The path to the PEM `}<inlineCode parentName="p">{`file`}</inlineCode>{` used as the root certificate authority.`}</p>
    <p><strong parentName="p">{`--context`}</strong>{`=`}<inlineCode parentName="p">{`name`}</inlineCode>{`
The context `}<inlineCode parentName="p">{`name`}</inlineCode>{` to apply for the given command.`}</p>
    <p><strong parentName="p">{`--ca-config`}</strong>{`=`}<inlineCode parentName="p">{`file`}</inlineCode>{`
The certificate authority configuration `}<inlineCode parentName="p">{`file`}</inlineCode>{`. Defaults to
$(step path)/config/ca.json`}</p>
    <h2>{`Examples`}</h2>
    <p>{`Create a webhook without an Authorization header:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`step ca provisioner webhook add my_provisioner my_webhook --url https://example.com
`}</code></pre>
    <p>{`Create a webhook with a bearer token:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`step ca provisioner webhook add my_provisioner my_webhook --url https://example.com --bearer-token-file token.txt
`}</code></pre>
    <p>{`Create a webhook with basic authentication:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`step ca provisioner webhook add my_provisioner my_webhook --url https://example.com --basic-auth-username user --basic-auth-password-file pass.txt
`}</code></pre>
    <p>{`Create a webhook that will never send a client certificate to the webhook server:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`step ca provisioner webhook add my_provisioner my_webhook --url https://example.com --disable-tls-client-auth
`}</code></pre>
    <p>{`Create a webhook that will only be called when signing x509 certificates:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`step ca provisioner webhook add my_provisioner my_webhook --url https://example.com --cert-type X509
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      